import styled from 'styled-components'

export const ResultsWrapper = styled.div`
  padding: 50px 0;
  position: relative;
  @media (min-width: 1024px){
    padding: 100px 0;
  }
`